import React from 'react'
import styled from 'styled-components'
import BackgroundImg from '../../Logos/backgronds/afr.png';
import Logo from '../../components/logo';
import { Marginer } from '../../components/marginer';
import theme from '../../themes';
import Btn from '../../components/button';
import { DownArrow } from '../../components/downArrow';
import { Navbar } from '../../components/navbar';
import { Element, scroller } from 'react-scroll'
import { ToggleButton } from '../../components/navbarToggler';
import { BrowserRouter as Router, Switch, Route, NavLink } from 'react-router-dom';
import Ourservices, { WhyTecspot } from './ourServices/index'
import whatWeDoSection from './whatWeDoSection'
import Homepage from '../homePage'
import { WhatWeDo } from './whatWedo';
import Navigation from '../../navigation';
import Header from '../../header';





const TopContainer = styled.div`
width: 100%;
height: 100vh;
padding:0;
background-image: url(${BackgroundImg});
background-repeat:no-repeat;
background-size:cover;

`;
const NavigationContainer = styled.div`
display:flex;
`

const BackgroundFilter = styled.div`
width:100%;
height:100vh;
background-color:rgba(55,55,55,0.89);
opacity:0.8;
display:flex;
flex-direction:column;
align-items:center;
`;

const MotivationalText = styled.h1`
margin:0;
font-size:33px;
font-weight:600;
line-height:1.3;
color:${theme.white};
text-align:center;
`;
const MotivationalText1 = styled.h1`
font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
margin:0;
font-size:33px;
font-weight:lighter;
line-height:1.3;
color:${theme.white};
text-align:center;
padding:1rem;
`;

const DownArrowContainer = styled.div` 

`;

export function TopSection(){

  //  const scrollToNextSection = () =>{
  //   scroller.scrollTo("whatwedo", {smooth: true, duration:"1000"})
  // }

return (
  <div>
  <TopContainer>   
 <BackgroundFilter>
  <ToggleButton></ToggleButton>
    <Marginer direction="vertical" margin="8rem"></Marginer>
      <Marginer direction="vertical" margin="3rem"></Marginer>
      <Header>Web Design and Development Company</Header>
      <Header>Graphics Design and SEO</Header>

      <MotivationalText1>If you need a website development in Nigeria, you want your business to get across to your potential customers, choose <b>Tecspot</b>.</MotivationalText1>
    <Marginer direction="vertical" margin="2.5rem"></Marginer>
   <NavigationContainer>
 <Navigation>
   <NavLink to="/web-design">Check Our Work</NavLink>
 </Navigation>
 </NavigationContainer> 
 <Marginer direction="vertical" margin="10rem" ></Marginer>
 <Marginer direction="vertical" margin="5rem" ></Marginer>
</BackgroundFilter> 
</TopContainer>     
     </div>
)
}

